import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { IDPSyncUsersButton } from '@modules/users/id-provider/idp-sync-users-button';
import { PageTitle } from '@common/page-layout/page-title';
import { useServerConfigContext } from '@common/server-config-context/server-config-context';
import UsersPageBody from './users-page-body';
export default function UsersAdminPage() {
    const serverConfig = useServerConfigContext();
    const idpImportEnabled = serverConfig.hasIdpIntegration();
    return (_jsxs(_Fragment, { children: [_jsx(PageTitle, { title: "Users", rightPanel: idpImportEnabled && _jsx(IDPSyncUsersButton, {}) }), _jsx(UsersPageBody, {})] }));
}
